/**
 * Created by AlexanderC on 6/15/15.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AbstractDriver = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _deepCore = require('deep-core');

var _deepCore2 = _interopRequireDefault(_deepCore);

var _crypto = require('crypto');

var _crypto2 = _interopRequireDefault(_crypto);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Abstract log driver
 */
let AbstractDriver = exports.AbstractDriver = function (_Core$OOP$Interface) {
  _inherits(AbstractDriver, _Core$OOP$Interface);

  function AbstractDriver() {
    _classCallCheck(this, AbstractDriver);

    return _possibleConstructorReturn(this, (AbstractDriver.__proto__ || Object.getPrototypeOf(AbstractDriver)).call(this, ['log']));
  }

  /**
   * @param {*} context
   * @returns {String}
   */


  _createClass(AbstractDriver, null, [{
    key: 'plainifyContext',
    value: function plainifyContext(context) {
      let type = typeof context;
      var plainContext;

      if (type === 'object') {
        plainContext = JSON.stringify(context);
      } else if (context instanceof Object) {
        plainContext = `${type}: ${context.toString()}`;
      } else {
        plainContext = context.toString();
      }

      return plainContext;
    }

    /**
     * @returns {String}
     */

  }, {
    key: '_md5',


    /**
     * @param {String} str
     * @returns {String}
     */
    value: function _md5(str) {
      return _crypto2.default.createHash('md5').update(str).digest('hex');
    }
  }, {
    key: 'datetime',
    get: function get() {
      return new Date().toISOString();
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'timeString',
    get: function get() {
      return new Date().toTimeString();
    }
  }]);

  return AbstractDriver;
}(_deepCore2.default.OOP.Interface);


//////////////////
// WEBPACK FOOTER
// ../~/deep-log/lib.compiled/Driver/AbstractDriver.js
// module id = 48
// module chunks = 0